import styled from "styled-components"
import AniLink from "gatsby-plugin-transition-link/AniLink"

const ListAdressesHeader = styled.div`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
  border: 1px solid ${(props) => props.theme.a_color_gradients.a_light};
  border-left: 6px solid ${(props) => props.theme.b_color_gradients.b_dark};
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
`

const AllBtn = styled(AniLink)`
  &::after,
  &::before {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
  color: ${(props) => props.theme.c_color_gradients.c_dark}!important;
  border: 1px solid ${(props) => props.theme.a_color_gradients.a_light};
  background-color: ${(props) => props.theme.a_color_gradients.a_medium};
`

const ListAdressesFiltersTaxo = styled.div`
  &:hover {
    color: ${(props) => props.theme.b_color_gradients.b_light};
  }
  color: ${(props) =>
    props.activeBool === false
      ? props.theme.c_color_gradients.c_dark
      : props.theme.b_color_gradients.b_light};
`

export { ListAdressesHeader, AllBtn, ListAdressesFiltersTaxo }
